import { Popover, Tag } from 'antd'
import { PhoneOutlined, TableOutlined } from '@ant-design/icons'
import { t } from 'i18next'
import React from 'react'
import { Link } from 'react-router-dom'
import { APPOINTMENT_COLORS } from '../../Common/Color'
import dayjs from 'dayjs'
import { appointmentTitle } from '../../Common/Common'

const AppointmentContent = (appointment) => (
  <>
    <Tag color={t(`Admin.Appointment.stateColor.${appointment?.state}`)} >{t(`Admin.Appointment.state.${appointment?.state}`)}</Tag>
    <br />
    <PhoneOutlined /> <i>{appointment?.phone}</i> <TableOutlined /> <i>{appointment?.digicode}</i>
  </>
)

const appointmentClassName = (appointment) => {
  if (!appointment.sms_confirmed || ['auto_cancel', 'cancel'].includes(appointment.state)) {
    return 'appointment-stripped'
  }
}

const transformAppointment = (appointment) => ({
  ...appointment,
  start: dayjs(appointment.begin_date).format(),
  end: dayjs(appointment.end_date).subtract(1, 'second').format(),
  color: APPOINTMENT_COLORS[appointment.type],
  title: appointmentTitle(appointment),
  className: appointmentClassName(appointment)
})

export default function OneLineAppointment ({ appointment, onCalendar = true }) {
  const expendedAppointment = transformAppointment(appointment)
  const from = onCalendar ? 'calendar' : 'event'
  const style = onCalendar ? { color: 'inherit', textDecoration: 'inherit' } : { backgroundColor: expendedAppointment.color, color: 'white', padding: '0 5px', borderRadius: '5px' }
  return (
    <Popover content={() => AppointmentContent(expendedAppointment)} title={expendedAppointment.title}>
      <Link style={style} to={`/admin/appointments/${expendedAppointment.id}?from=${from}`}>
        <div style={{ whiteSpace: 'nowrap', overflowX: 'clip', fontSize: '15px' }} >
          {expendedAppointment.title}
        </div>
      </Link>
    </Popover>
  )
}
